import * as React from 'react';

import { ActionLink, UIText1 } from '@cian/ui-kit';

import * as styles from './RedesignedPaginationError.css';

export type TRedesignedPaginationErrorProps = {
  onRetry: () => void;
};

export const RedesignedPaginationError: React.FC<TRedesignedPaginationErrorProps> = ({ onRetry }) => (
  <div className={styles['error']}>
    <UIText1 color="text-secondary-default">Произошла ошибка</UIText1>
    <span className={styles['error-button']}>
      <ActionLink type="button" onClick={onRetry} fontWeight="bold">
        Попробовать снова
      </ActionLink>
    </span>
  </div>
);
